import { render, staticRenderFns } from "./DenseBindingTree.vue?vue&type=template&id=2fa112f0&scoped=true&lang=html&"
import script from "./DenseBindingTree.vue?vue&type=script&lang=js&"
export * from "./DenseBindingTree.vue?vue&type=script&lang=js&"
import style0 from "./DenseBindingTree.vue?vue&type=style&index=0&id=2fa112f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa112f0",
  null
  
)

export default component.exports